module.exports = __webpack_public_path__ + "static/gallery-4@2x-d1d0e828fd201213afc9dab528ca0ada.jpg";